<template>
    <div>
        <van-form ref="basicInformation" @failed="onFailed" :show-error="false" class="default-form">

            <van-field v-model="basicInformation.exporter" placeholder="请填写出口商的名称和地址(英文大写)" autosize disabled clearable
                       label-width="100%"
                       type="textarea" rows="2" class="van-field-border van-field-textarea"
                       :rules="rules.exporterRule">
                <span slot="label"><span class="textarea-required">出口商(Exporter)</span><span class="select-btn"
                                                                                             @click="exporterVisible = true">选择</span></span>
            </van-field>

            <van-field v-model="basicInformation.importer" placeholder="请填写收货方或进口商的名称和地址(英文大写)" autosize disabled clearable
                       label-width="100%"
                       type="textarea" rows="2" class="van-field-border van-field-textarea"
                       :rules="rules.importerRule">
                <span slot="label"><span class="textarea-required">收货方/进口商(Consignee)</span><span class="select-btn"
                                                                                                  @click="importerVisible = true">选择</span></span>
            </van-field>

            <van-field v-model="basicInformation.producer" placeholder="请填写生产商的名称和地址(英文大写)" autosize disabled clearable
                       label-width="100%"
                       type="textarea" rows="2" class="van-field-border van-field-textarea"
                       :rules="rules.producerRule">
                <span slot="label"><span class="textarea-required">生产商(Producer)</span><span class="select-btn"
                                                                                             @click="producerVisible = true">选择</span></span>
            </van-field>
            <!--生产商选择标签-->
            <van-row class="producer-tags">
                <van-tag type="primary" v-for="(item,index) in tagList" :key="index" @click="producerField(item)">{{
                    item.label }}
                </van-tag>
            </van-row>

            <van-field v-model="basicInformation.transportLine" placeholder="请点击编辑按钮，完善信息后自动填入" autosize clearable
                       label-width="100%"
                       type="textarea" rows="2" class="van-field-border van-field-textarea" :readonly="true"
                       :rules="rules.transportLineRule">
                <span slot="label"><span class="textarea-required">运输路线(Means of transport and route)</span><span
                        class="select-btn" @click="editTransportLineVisible = true">编辑</span></span>
            </van-field>

            <van-field v-model="basicInformation.applyAddr" placeholder="请选择证书申请地点" input-align="right"
                       error-message-align="right"
                       :rules="rules.applyAddrRule" :readonly="true" class="van-field-border van-field-required"
                       @click="applyAddrVisible = true">
                <span slot="label">申请地点<i class="extra-cont">Place of application</i> </span>
                <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
            </van-field>

            <van-field v-model="basicInformation.applyTime" placeholder="请填写申请日期" input-align="right"
                       error-message-align="right"
                       :rules="rules.applyTimeRule" :readonly="true" class="van-field-border van-field-required"
                       @click="showDataToast('申请日期')">
                <span slot="label">申请日期<i class="extra-cont">Date of application</i> </span>
                <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
            </van-field>

            <van-field v-model="basicInformation.signAddr" placeholder="请选择证书签署地点" input-align="right"
                       error-message-align="right"
                       :rules="rules.signAddrRule" :readonly="true" class="van-field-border van-field-required"
                       @click="signAddrVisible = true">
                <span slot="label">签署地点<i class="extra-cont">Place of issuance</i> </span>
                <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
            </van-field>

            <van-field v-model="basicInformation.signTime" placeholder="请选择证书签署日期" input-align="right"
                       error-message-align="right"
                       :rules="rules.signTimeRule" :readonly="true" class="van-field-border van-field-required"
                       @click="showDataToast('签署日期')">
                <span slot="label">签署日期<i class="extra-cont">Date of issuance</i> </span>
                <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
            </van-field>

            <van-field v-model="basicInformation.weightMarkupLabel" label="货物的单位名称" placeholder="请选择需要在证书上显示的货物单位名称"
                       input-align="right" error-message-align="right"
                       :rules="rules.weightMarkupRule" :readonly="true" label-width="auto"
                       class="van-field-border van-field-required"
                       @click="weightMarkupVisible = true">
                <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
            </van-field>

            <van-field v-model="basicInformation.remark" label="备注(Remarks)(BOX 8)" label-width="100%" type="textarea"
                       rows="1" clearable class="van-field-border van-field-textarea"></van-field>
        </van-form>

        <!--进口商选择-->
        <van-popup v-model="importerVisible" position="bottom" class="page-popup select-popup" get-container="body">
            <importer v-if="importerVisible" @selectImporter="selectImporter"/>
        </van-popup>

        <!--出口商选择-->
        <van-popup v-model="exporterVisible" position="bottom" class="page-popup select-popup" get-container="body">
            <exporter v-if="exporterVisible" @selectExporter="selectExporter"/>
        </van-popup>

        <!--生产商选择-->
        <van-popup v-model="producerVisible" position="bottom" class="page-popup select-popup" get-container="body">
            <producer v-if="producerVisible" @selectProducer="selectProducer"/>
        </van-popup>

        <!--编辑运输路线-->
        <van-popup v-model="editTransportLineVisible" position="bottom" class="page-popup" get-container="body">
            <edit-transport-line @hideEditTransportLine="editTransportLineVisible = false"
                                 @editTransportLine="editTransportLine"/>
        </van-popup>

        <!--毛净重标识-->
        <van-popup v-model="weightMarkupVisible" position="bottom">
            <common-picker @close="weightMarkupVisible = false" @confirm="weightMarkupConfirm"
                           :columns="weightMarkupOptions"></common-picker>
        </van-popup>

        <!--申请地点-->
        <van-popup v-model="applyAddrVisible" position="bottom">
            <common-picker @close="applyAddrVisible = false" @confirm="applyAddrConfirm"
                           :columns="addressOptions"></common-picker>
        </van-popup>

        <!--签署地点-->
        <van-popup v-model="signAddrVisible" position="bottom">
            <common-picker @close="signAddrVisible = false" @confirm="signAddrConfirm"
                           :columns="addressOptions"></common-picker>
        </van-popup>

        <!--申请日期-->
        <van-popup v-model="applyTimeVisible" position="bottom">
            <date-picker @close="applyTimeVisible = false" @confirm="applyTimeConfirm"></date-picker>
        </van-popup>

        <!--签署日期-->
        <van-popup v-model="signTimeVisible" position="bottom">
            <date-picker @close="signTimeVisible = false" @confirm="signTimeConfirm"></date-picker>
        </van-popup>
    </div>
</template>

<script>
    import Importer from './Importer'
    import Exporter from './Exporter'
    import Producer from './Producer'
    import EditTransportLine from '../../component/EditTransportLine'


    import BasicInformation from '../../dto/BasicInformation'
    import DatePicker from '../../../component/DatePicker'
    import CommonPicker from '../../../component/CommonPicker'
    import dictionaryService from "../../../component/dictionary-service";
    import moment from "moment";

    export default {
        name: "BasicInformation",
        components: {
            Importer, Exporter, Producer, EditTransportLine, DatePicker, CommonPicker
        },
        data() {
            return {
                basicInformation: new BasicInformation(),
                rules: BasicInformation.getRules(),
                importerVisible: false, //进口商
                exporterVisible: false, //出口商
                producerVisible: false, //生产商
                editTransportLineVisible: false, //编辑运输路线
                applyTimeVisible: false,
                signTimeVisible: false,
                applyAddrVisible: false,
                signAddrVisible: false,
                weightMarkupVisible: false,
                transportList: null,
                tagList: [{label: 'SEE BOX 8'}, {label: 'CONFIDENTIAL'}, {label: 'NOT AVAILABLE'}],
                weightMarkupOptions: [],
                addressOptions: [],
                basicInformationErrors: null,
            }
        },
        created() {
            const formatTime = moment(new Date()).format('YYYY-MM-DD');
            this.basicInformation.applyTime = formatTime;
            this.basicInformation.signTime = formatTime;
            this.loadDictionaryOptions();
        },
        methods: {
            async loadDictionaryOptions() {
                const result = await dictionaryService.getDictionaryIncludeItemsByIds([3, 15]);
                if (result.isSuccess()) {
                    this.weightMarkupOptions = result.data.find(item => item.id == 3).items.filter(item => item.enabled);
                    this.addressOptions = result.data.find(item => item.id == 15).items.filter(item => item.enabled);
                }
            },
            showDataToast(label) {
                this.$toast(`${label}为当前日期`);
            },
            /**
             * Description 出口商选择
             * Date 2022/7/30
             */
            selectExporter(exporter) {
                this.basicInformation.exporterId = exporter.id;
                this.basicInformation.exporter = `${exporter.nameEnglish}\n${exporter.addressEnglish}`;
                this.exporterVisible = false;
            },
            /**
             * Description 进口商选择
             * Date 2022/7/30
             */
            selectImporter(importer) {
                this.basicInformation.importerId = importer.id;
                this.basicInformation.importer = `${importer.customerNameEnglish}\n${importer.addressEnglish}`;
                this.importerVisible = false;
            },
            /**
             * Description 生产商选择
             * Date 2022/7/30
             */
            selectProducer(producer) {
                this.basicInformation.producerId = producer.id;
                this.basicInformation.producer = `${producer.nameEnglish}\n${producer.addressEnglish}`;
                this.producerVisible = false;
            },
            /**
             * Description 编辑运输路线
             * Date 2022/7/30
             */
            editTransportLine(transportLine) {
                this.basicInformation.transportLine = transportLine.transportLine;
                this.transportList = transportLine;
                this.editTransportLineVisible = false;
            },
            applyTimeConfirm(selectedApplyTime) {
                this.basicInformation.applyTime = selectedApplyTime;
                this.applyTimeVisible = false;
            },
            signTimeConfirm(selectedSignTime) {
                this.basicInformation.signTime = selectedSignTime;
                this.signTimeVisible = false;
            },
            signAddrConfirm(selectedSignAddr) {
                this.basicInformation.signAddr = selectedSignAddr.value + " CHINA";
                this.basicInformation.signAddrLabel = selectedSignAddr.label;
                this.signAddrVisible = false;
            },
            applyAddrConfirm(selectedApplyAddr) {
                this.basicInformation.applyAddr = selectedApplyAddr.value + " CHINA";
                this.basicInformation.applyAddrLabel = selectedApplyAddr.label;
                this.applyAddrVisible = false;
            },
            weightMarkupConfirm(selectedWeightMarkup) {
                this.basicInformation.weightMarkup = selectedWeightMarkup.value;
                this.basicInformation.weightMarkupLabel = selectedWeightMarkup.label;
                this.weightMarkupVisible = false;
            },
            producerField(item) {
                this.basicInformation.producerModel = item.label;
                this.basicInformation.producer = item.label;
            },
            validate() {
                return this.$refs["basicInformation"].validate().then(() => {
                    return new Promise(resolve => resolve(true))
                }).catch(() => {
                        return new Promise(resolve => resolve(false))
                    }
                )
            },
            onFailed(error) {
                this.basicInformationErrors = error;
            },
            getBasicInformation() {
                this.basicInformation.originCertificateTransport = this.transportList;
                return this.basicInformation;
            }
        }
    }
</script>

<style lang="scss" scoped>
.select-popup {
  max-height: 90%;
}
</style>